import { API_URL } from "settings";

// Reads the chat's NDJSON stream and hands one parsed event at a time to onEvent.
const requestChatStream = async (chatId, onEvent, signal) => {

  const response = await fetch(`${API_URL}/chats/stream/?chat_id=${chatId}`, {
    headers: {
      "Accept": "application/x-ndjson",
      "Accept-Language": "en",
      "Authorization": `Token ${sessionStorage.getItem("token")}`,
    },
    signal,
  });

  if (!response.ok || !response.body)
    throw response;

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";

  let isDone = false;
  while (!isDone) {
    const { value, done } = await reader.read();
    isDone = done;
    buffer += decoder.decode(value, { stream: !done });

    // A chunk can cut a line in half, so the trailing fragment waits for the next read.
    const lines = buffer.split("\n");
    buffer = lines.pop();
    lines.filter(Boolean).forEach(line => onEvent(JSON.parse(line)));

    if (isDone && buffer) onEvent(JSON.parse(buffer));
  }
};

export default requestChatStream;
